import pageLoad from './pageLoad'
import customEvent from './customEvent'
import router from 'utils/router'
import { ENV } from 'gatsby-env-variables'

const GTMID = `GTM-NSJJGTX` //apenas Recovery usa addGTM()

const addGTM = () => {
  return new Promise(() => {
    const utmSource = router.getQueryString('utm_source') || 'recovery'

    const gaTags = {
      rvStage: 'G-8HNRL15TYC',
      recoveryProd: 'UA-45367306-5',
    }

    const optimizeTags = {
      rvStage: 'OPT-PMD2PS8',
      recoveryProd: 'OPT-MRNMXPX',
    }

    const gaTag = ENV === 'prod' ? gaTags.recoveryProd : gaTags.rvStage

    const optimizeTag =
      ENV === 'prod' ? optimizeTags.recoveryProd : optimizeTags.rvStage

    const gaScript = document.createElement('script')
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaTag}`
    gaScript.async = true
    document.head.appendChild(gaScript)

    if (ENV === 'prod') {
      // GA4 novo da RV visando migração futura
      const ga4Script = document.createElement('script')
      gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-3VDXGSTV7S'
      gaScript.async = true
      document.head.appendChild(ga4Script)

      // UA que era utilizada no segment
      const uaConversionScript = document.createElement('script')
      gaScript.src =
        'https://www.googletagmanager.com/gtag/js?id=UA-204852905-1'
      gaScript.async = true
      document.head.appendChild(uaConversionScript)

      const newGAConfig = document.createElement('script')
      newGAConfig.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-3VDXGSTV7S');
      gtag('config', 'UA-204852905-1');`

      document.head.appendChild(newGAConfig)
    }

    const optimizeScript = document.createElement('script')
    optimizeScript.src = `https://www.googleoptimize.com/optimize.js?id=${optimizeTag}`
    optimizeScript.async = true
    document.head.appendChild(optimizeScript)

    const script2 = document.createElement('script')
    script2.src = 'https://www.googletagmanager.com/gtag/js?id=AW-316483997'
    script2.async = true
    document.head.appendChild(script2)

    const script2Inner = document.createElement('script')
    script2Inner.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-316483997');
			gtag('config', '${gaTag}', { 'optimize_id': '${optimizeTag}'});`
    document.head.appendChild(script2Inner)

    if (utmSource !== 'recovery') {
      const script = document.createElement('script')
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
			j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
			'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${GTMID}');
    `
      document.body.appendChild(script)
    }

    if (utmSource === 'reneg-itau') {
      const renegGA = document.createElement('script')
      renegGA.src =
        'https://www.googletagmanager.com/gtag/js?id=UA-140135526-14'
      renegGA.async = true
      document.head.appendChild(renegGA)

      const renegGAConfig = document.createElement('script')
      renegGAConfig.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-140135526-14');`

      document.head.appendChild(renegGAConfig)
    }
  })
}

export default {
  pageLoad,
  customEvent,
  addGTM,
}
